//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AcuvueBonusesTableMobile',

  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    newUserName: {
      type: String,
      default: ''
    },
    expertUserName: {
      type: String,
      default: ''
    }
  },

  data: function () {
    return {
      activeUserTable: 'Новичок',
    }
  },

  computed: {
    newUserData: function () {
      let arr = [];
      this.tableData.forEach((item) => {
        item.grades.forEach((grade) => {
          if (grade.title === this.newUserName) {
            console.log('grade', grade)
            arr.push({
              rowName: item.rowName,
              ...grade,
            })
          }
        })
      });
      return arr
    },
    expertUserData: function () {
      let arr = [];
      this.tableData.forEach((item) => {
        item.grades.forEach((grade) => {
          if (grade.title === this.expertUserName) {
            arr.push({
              rowName: item.rowName,
              ...grade,
            })
          }
        })
      });
      return arr
    },
    activeTable: function () {
      let itemsList = [];
      if (this.activeUserTable === this.newUserName) {
        itemsList = this.newUserData;
      }
      if (this.activeUserTable === this.expertUserName) {
        itemsList = this.expertUserData;
      }
      return itemsList;
    }
  },
  methods: {
    setActiveTableData: function (userPropName) {
      if (this.activeUserTable === userPropName) {
        this.activeUserTable = '';
        return
      }
      this.activeUserTable = userPropName;
    }
  }
}
